<template>
  <div :is="tag" v-if="isAdmin">
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MasterAdminPermissionGuardContainer',
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    ...mapGetters({ isAdmin: 'UserAuthStore/isAdmin' })
  }
}
</script>
